// Oyun sürümü ve sürüm notları. Yeni sürümde APP_VERSION'ı artır ve CHANGELOG'un başına ekle;
// oyuncular yeni sürümü ilk açtıklarında notlar bir kez popup olarak gösterilir.
export const APP_VERSION = '0.9.4';

export const CHANGELOG = [
  {
    version: '0.9.4',
    date: '2026-11-05',
    items: [
      { tr: 'Bot doğrulaması kısa sürede ikinci kez gerekirse oyuna giriş 5 dakika engellenir.', en: 'If the bot check triggers twice in a short time, game access is blocked for 5 minutes.' },
      { tr: 'Eşyalardaki soketler yeni, renkli ve parıltılı tasarımla gösteriliyor.', en: 'Item sockets have a new colorful, glowing design.' },
      { tr: 'Sürüm notları için yeni menü simgesi.', en: 'New menu icon for version notes.' },
    ],
  },
  {
    version: '0.9.3',
    date: '2026-11-05',
    items: [
      { tr: 'Taş takma tutmazsa soket "kırık taş" ile dolar; kırık taşın etkisi yoktur.', en: 'A failed stone insert fills the socket with a "broken stone" that has no effect.' },
      { tr: 'Nesne Market: Taş Temizleme Kiti — silah/zırhın üstüne sürükleyince tüm soketleri temizler.', en: 'Item Shop: Stone Cleaning Kit — drag onto a weapon/armor to clear all sockets.' },
      { tr: 'Boş soketi olmayan eşyanın üstüne taş getirince eşya kırmızı görünür.', en: 'Items with no empty socket turn red when you drag a stone over them.' },
    ],
  },
  {
    version: '0.9.2',
    date: '2026-11-05',
    items: [
      { tr: 'Bot koruması: savaş ve zindanda insan dışı düzenli hareketler algılanır.', en: 'Bot protection: inhuman, overly regular inputs are detected in battle and dungeons.' },
      { tr: 'Çok düzenli ve tekrar eden komutlar algılanınca "BOT DEĞİLİM" doğrulaması istenir; doğrulayınca savaş kaldığı yerden sürer, hiçbir şey kaybedilmez.', en: 'Highly regular, repeated inputs trigger an "I\'M NOT A BOT" check; after verifying the fight continues where it left off and nothing is lost.' },
      { tr: 'Sürüm notları eklendi (ana menü).', en: 'Version notes added (main menu).' },
      { tr: 'Savaşta konum satırında "konuma göre farklı canavarlar" ipucu.', en: 'Battle location line now hints that monsters differ by location.' },
    ],
  },
  {
    version: '0.9.1',
    date: '2026-11-05',
    items: [
      { tr: 'Soket sistemi: düşen silahlarda 3, zırhlarda 4 sokete kadar.', en: 'Sockets: dropped weapons up to 3, armors up to 4 sockets.' },
      { tr: '6 değerli taş ve 7 rune, 4 seviye; taş + rune kombinasyon bonusları.', en: '6 gems and 7 runes with 4 levels; gem + rune combo bonuses.' },
      { tr: 'Taş birleştirme Craft tezgâhında (3 aynı taş → bir üst seviye).', en: 'Combine stones at the Craft table (3 identical → next level).' },
      { tr: 'Taşı silah/zırhın üstüne sürükleyince boş sokete takılır.', en: 'Drag a stone onto a weapon/armor to insert it into an empty socket.' },
      { tr: 'Taş düşme, takma ve birleştirme sesleri.', en: 'Sounds for stone drop, insert and combine.' },
      { tr: 'Açılan mide/sandık ve üretilen eşyalar boş yer varsa doğrudan envantere dizilir.', en: 'Items from stomachs/chests and crafting go straight into free inventory slots.' },
      { tr: 'Wiki: Soket & Taşlar sekmesi.', en: 'Wiki: Sockets & Stones tab.' },
    ],
  },
  {
    version: '0.9.0',
    date: '2026-11-04',
    items: [
      { tr: 'Vuruş hissi: yanıp sönme, kıvılcım, sarsılma ve beceri tozu.', en: 'Hit feel: flash, sparks, shake and skill dust.' },
      { tr: 'Video izleyerek Ruh Parası ve savaş buff\'ları; günlük video görevi.', en: 'Watch videos for Soul Coins and battle buffs; daily video quest.' },
      { tr: 'Eşya düşünce telefon titreşimi.', en: 'Phone vibration when an item drops.' },
      { tr: 'Arena daveti kabul edilince savaş/zindandan çıkılıp maça girilir.', en: 'Accepting an arena match leaves the current battle/dungeon.' },
      { tr: 'Google/Apple ile aynı e-posta tek hesapta birleşir.', en: 'Google/Apple sign-in with the same email links to one account.' },
    ],
  },
];

export const changelogText = (item, lang) => (lang === 'tr' ? item.tr : item.en);
